import script from "./people.vue?vue&type=script&setup=true&lang=js"
export * from "./people.vue?vue&type=script&setup=true&lang=js"

import "./people.vue?vue&type=style&index=0&id=8ba61214&lang=scss&scoped=true"
import "./people.vue?vue&type=style&index=1&id=8ba61214&lang=scss"
import "./people.vue?vue&type=style&index=2&id=8ba61214&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ba61214"]])

export default __exports__